<template>
  <div>
    <CrossWalk-Map />
    <br>
    <CrossWalk-Table />
  </div>
</template>

<script>
// import VMSMenuTop from '@/views/vms/sub/VMSMenuTop.vue'
import CrossWalkMap from '@/views/crosswalk/total/CrossWalkMap.vue'
import CrossWalkTable from '@/views/crosswalk/total/CrossWalkTable.vue'

export default {
  components: {
    // VMSMenuTop,
    CrossWalkMap,
    CrossWalkTable,
  },
}
</script>

<style>

</style>
